module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "phone-viewport",
    staticStyle: {
      "z-index": "5"
    }
  }, [_c('div', {
    staticClass: "bottom-bar-bg"
  }, [_c('div', {
    staticClass: "bottom-bar-item first",
    on: {
      "click": function($event) {
        return _vm.onClickItem(1)
      }
    }
  }, [_c('div', {
    staticClass: "icon-outer"
  }, [_c('div', {
    staticClass: "icon-inner"
  }, [_c('svg', {
    class: _vm.selectedItem === 'bottom-bar-item-home' ? 'tinted-icon' : 'default-icon',
    attrs: {
      "width": "26",
      "height": "29",
      "viewBox": "0 0 26 29",
      "fill": "#FFFFFF",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2.58072 25.4579H8.27902V16.8777C8.27902 16.4416 8.42652 16.076 8.72153 15.781C9.01653 15.486 9.38209 15.3385 9.81821 15.3385H15.7784C16.2145 15.3385 16.5801 15.486 16.8751 15.781C17.1701 16.076 17.3176 16.4416 17.3176 16.8777V25.4579H23.0159V10.3935C23.0159 10.3061 22.9968 10.227 22.9586 10.1561C22.9203 10.0851 22.8685 10.0223 22.803 9.96775L13.1094 2.68117C13.0221 2.60476 12.9184 2.56656 12.7983 2.56656C12.6782 2.56656 12.5745 2.60476 12.4872 2.68117L2.79359 9.96775C2.72811 10.0223 2.67625 10.0851 2.63802 10.1561C2.59982 10.227 2.58072 10.3061 2.58072 10.3935V25.4579ZM0.0263672 25.4579V10.3935C0.0263672 9.90607 0.135397 9.44433 0.353457 9.00823C0.571518 8.57214 0.872936 8.21301 1.25771 7.93083L10.9513 0.6279C11.4892 0.217437 12.104 0.012207 12.7957 0.012207C13.4873 0.012207 14.1038 0.217437 14.6453 0.6279L24.3389 7.93083C24.7237 8.21301 25.0251 8.57214 25.2431 9.00823C25.4612 9.44433 25.5702 9.90607 25.5702 10.3935V25.4579C25.5702 26.1543 25.3186 26.7541 24.8154 27.2573C24.3121 27.7606 23.7123 28.0122 23.0159 28.0122H16.3024C15.8663 28.0122 15.5008 27.8647 15.2057 27.5697C14.9107 27.2747 14.7632 26.9091 14.7632 26.473V17.8928H10.8334V26.473C10.8334 26.9091 10.6859 27.2747 10.3909 27.5697C10.0958 27.8647 9.73027 28.0122 9.29418 28.0122H2.58072C1.88428 28.0122 1.28445 27.7606 0.781233 27.2573C0.277989 26.7541 0.0263672 26.1543 0.0263672 25.4579Z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "text-outer"
  }, [_c('div', {
    staticClass: "text-inner"
  }, [_c('p', {
    class: _vm.selectedItem === 'bottom-bar-item-home' ? 'tinted-text' : 'default-text'
  }, [_vm._v(_vm._s(_vm.locale.t("label_home")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-bar-item",
    on: {
      "click": function($event) {
        return _vm.onClickItem(2)
      }
    }
  }, [_c('div', {
    staticClass: "icon-outer"
  }, [_c('div', {
    staticClass: "icon-inner"
  }, [_c('svg', {
    class: _vm.selectedItem === 'bottom-bar-item-trainings' ? 'tinted-icon' : 'default-icon',
    attrs: {
      "width": "30",
      "height": "15",
      "viewBox": "0 0 30 15",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.49464 8.86575L7.49464 13.6236C7.49463 13.9777 7.36964 14.2835 7.11966 14.5409C6.86969 14.7983 6.55679 14.927 6.18097 14.9271C5.82683 14.927 5.51935 14.802 5.25852 14.5521C4.99771 14.3021 4.86187 13.9946 4.85102 13.6296L4.83479 12.5073L3.81228 12.5073C3.42284 12.5073 3.09716 12.3763 2.83525 12.1144C2.57336 11.8525 2.44241 11.5268 2.44241 11.1374L2.44241 8.89827L1.36091 8.88201C0.999957 8.88202 0.685822 8.74837 0.418503 8.48105C0.151183 8.21373 0.0175237 7.88875 0.0175237 7.50612C0.0175237 7.14515 0.148478 6.8283 0.410386 6.55557C0.67228 6.28283 0.989122 6.14104 1.36091 6.13022L2.44241 6.11396L2.44241 3.87483C2.44241 3.48538 2.57336 3.15971 2.83525 2.89782C3.09716 2.63591 3.42284 2.50496 3.81228 2.50496L4.83479 2.50498L4.85105 1.37238C4.85105 1.01825 4.97875 0.713485 5.23415 0.458084C5.48955 0.202683 5.80516 0.074976 6.18097 0.0749617C6.53512 0.074976 6.84259 0.205389 7.10341 0.466201C7.36422 0.727013 7.49463 1.03449 7.49464 1.38863V6.14648L21.5703 6.14647L21.5703 1.38863C21.5703 1.03449 21.6953 0.727012 21.9452 0.466201C22.1952 0.205389 22.5081 0.074976 22.884 0.0749617C23.2381 0.0749617 23.5456 0.199956 23.8064 0.449945C24.0672 0.699935 24.203 1.00741 24.2139 1.37238L24.2301 2.50498L25.2526 2.50496C25.6421 2.50496 25.9678 2.63591 26.2297 2.89782C26.4916 3.15971 26.6225 3.48538 26.6225 3.87483L26.6225 6.11396L27.704 6.13022C28.065 6.13021 28.3791 6.26386 28.6464 6.53118C28.9137 6.7985 29.0474 7.12348 29.0474 7.50611C29.0474 7.86708 28.9165 8.18393 28.6545 8.45666C28.3927 8.7294 28.0758 8.87119 27.704 8.88201L26.6225 8.89827L26.6225 11.1374C26.6225 11.5268 26.4916 11.8525 26.2297 12.1144C25.9678 12.3763 25.6421 12.5073 25.2526 12.5073L24.2301 12.5073L24.2139 13.6399C24.2139 13.994 24.0862 14.297 23.8308 14.5491C23.5754 14.801 23.2598 14.927 22.884 14.9271C22.5298 14.927 22.2223 14.7966 21.9615 14.5358C21.7007 14.275 21.5703 13.9675 21.5703 13.6134L21.5703 8.86575H7.49464Z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "text-outer"
  }, [_c('div', {
    staticClass: "text-inner"
  }, [_c('p', {
    class: _vm.selectedItem === 'bottom-bar-item-trainings' ? 'tinted-text' : 'default-text'
  }, [_vm._v(_vm._s(_vm.locale.t("label_trainings")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-bar-item",
    on: {
      "click": function($event) {
        return _vm.onClickItem(3)
      }
    }
  }, [_c('div', {
    staticClass: "icon-outer"
  }, [_c('div', {
    staticClass: "icon-inner"
  }, [_c('svg', {
    class: _vm.selectedItem === 'bottom-bar-item-payments' ? 'tinted-icon' : 'default-icon',
    attrs: {
      "width": "29",
      "height": "29",
      "viewBox": "0 0 29 29",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.386 27.1136C16.787 27.7127 16.052 28.0122 15.1811 28.0122C14.3102 28.0122 13.5752 27.7127 12.9761 27.1136L0.971271 15.1087C0.683109 14.8206 0.455618 14.4842 0.288801 14.0997C0.121983 13.7151 0.0385742 13.3051 0.0385742 12.8697V3.11574C0.0385742 2.26212 0.342425 1.53146 0.950126 0.92376C1.55783 0.316059 2.28849 0.012207 3.14211 0.012207H12.8961C13.3315 0.012207 13.7415 0.095615 14.1261 0.262433C14.5106 0.42925 14.8469 0.656742 15.1351 0.944905L27.14 12.9757C27.739 13.5748 28.0386 14.3054 28.0386 15.1677C28.0386 16.0299 27.739 16.7606 27.14 17.3597L17.386 27.1136ZM15.1892 24.9428L24.9432 15.1888L12.8961 3.11574H3.14211V12.8697L15.1892 24.9428ZM6.55258 8.5725C7.12099 8.5725 7.60414 8.37356 8.00203 7.97567C8.39992 7.57778 8.59887 7.09463 8.59887 6.52621C8.59887 5.9578 8.39992 5.47465 8.00203 5.07676C7.60414 4.67887 7.12099 4.47993 6.55258 4.47993C5.98417 4.47993 5.50102 4.67887 5.10313 5.07676C4.70524 5.47465 4.5063 5.9578 4.5063 6.52621C4.5063 7.09463 4.70524 7.57778 5.10313 7.97567C5.50102 8.37356 5.98417 8.5725 6.55258 8.5725ZM16.5134 20.4387L20.1945 16.7576C20.4446 16.5075 20.6435 16.212 20.7913 15.8709C20.9391 15.5299 21.013 15.1661 21.013 14.7796C21.013 14.0065 20.7402 13.3472 20.1945 12.8015C19.6488 12.2558 18.9894 11.983 18.2164 11.983C17.7844 11.983 17.3581 12.108 16.9375 12.3581C16.5169 12.6082 16.011 13.0289 15.4198 13.62C14.7377 12.9834 14.2034 12.5514 13.8169 12.324C13.4304 12.0967 13.0325 11.983 12.6232 11.983C11.8502 11.983 11.1908 12.2558 10.6452 12.8015C10.0995 13.3472 9.82664 14.0065 9.82664 14.7796C9.82664 15.1661 9.90053 15.5299 10.0483 15.8709C10.1961 16.212 10.3951 16.5075 10.6452 16.7576L14.3262 20.4387C14.6371 20.7496 15.0017 20.9051 15.4198 20.9051C15.838 20.9051 16.2025 20.7496 16.5134 20.4387Z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "text-outer"
  }, [_c('div', {
    staticClass: "text-inner"
  }, [_c('p', {
    class: _vm.selectedItem === 'bottom-bar-item-payments' ? 'tinted-text' : 'default-text'
  }, [_vm._v(_vm._s(_vm.locale.t("label_membership")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-bar-item last",
    on: {
      "click": function($event) {
        return _vm.onClickItem(4)
      }
    }
  }, [_c('div', {
    staticClass: "icon-outer"
  }, [_c('div', {
    staticClass: "icon-inner"
  }, [_c('svg', {
    class: _vm.selectedItem === 'bottom-bar-item-profile' ? 'tinted-icon' : 'default-icon',
    attrs: {
      "width": "29",
      "height": "29",
      "viewBox": "0 0 29 29",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.407 13.4227C12.5631 13.4227 10.9846 12.7661 9.67146 11.453C8.35834 10.1399 7.70177 8.56139 7.70177 6.71746C7.70177 4.8735 8.35834 3.29498 9.67146 1.98189C10.9846 0.668768 12.5631 0.012207 14.407 0.012207C16.251 0.012207 17.8295 0.668768 19.1426 1.98189C20.4557 3.29498 21.1123 4.8735 21.1123 6.71746C21.1123 8.56139 20.4557 10.1399 19.1426 11.453C17.8295 12.7661 16.251 13.4227 14.407 13.4227ZM0.0385742 25.1017V23.7533C0.0385742 22.8151 0.293407 21.9462 0.803074 21.1467C1.31271 20.3473 1.99366 19.7326 2.84594 19.3028C4.73964 18.3744 6.64992 17.678 8.57677 17.2138C10.5036 16.7496 12.447 16.5175 14.407 16.5175C16.367 16.5175 18.3104 16.7496 20.2373 17.2138C22.1641 17.678 24.0744 18.3744 25.9681 19.3028C26.8204 19.7326 27.5013 20.3473 28.011 21.1467C28.5206 21.9462 28.7755 22.8151 28.7755 23.7533V25.1017C28.7755 25.9098 28.4924 26.5969 27.9263 27.163C27.3601 27.7291 26.673 28.0122 25.865 28.0122H2.94906C2.141 28.0122 1.45392 27.7291 0.8878 27.163C0.321649 26.5969 0.0385742 25.9098 0.0385742 25.1017ZM2.91223 25.1386H25.9018V23.7533C25.9018 23.3652 25.7894 23.006 25.5647 22.6756C25.34 22.3453 25.0348 22.0757 24.6492 21.8669C22.9987 21.054 21.3157 20.4381 19.6002 20.0193C17.8847 19.6005 16.1537 19.3912 14.407 19.3912C12.6604 19.3912 10.9293 19.6005 9.21387 20.0193C7.4984 20.4381 5.8154 21.054 4.16487 21.8669C3.77925 22.0757 3.47408 22.3453 3.24936 22.6756C3.0246 23.006 2.91223 23.3652 2.91223 23.7533V25.1386ZM14.407 10.5491C15.4607 10.5491 16.3627 10.1739 17.1131 9.42353C17.8634 8.67317 18.2386 7.77115 18.2386 6.71746C18.2386 5.66377 17.8634 4.76175 17.1131 4.01139C16.3627 3.26104 15.4607 2.88586 14.407 2.88586C13.3533 2.88586 12.4513 3.26104 11.701 4.01139C10.9506 4.76175 10.5754 5.66377 10.5754 6.71746C10.5754 7.77115 10.9506 8.67317 11.701 9.42353C12.4513 10.1739 13.3533 10.5491 14.407 10.5491Z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "text-outer"
  }, [_c('div', {
    staticClass: "text-inner"
  }, [_c('p', {
    class: _vm.selectedItem === 'bottom-bar-item-profile' ? 'tinted-text' : 'default-text'
  }, [_vm._v(_vm._s(_vm.locale.t("label_account")))])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2aca5784!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/BottomBar.vue
// module id = 745
// module chunks = 0